import { useEffect, useRef } from 'react';
import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';

/**
 * Atacar um inocente sendo inocente (Configurações › Jogabilidade, padrão ligado): o jogo pergunta antes do
 * primeiro golpe ou magia de ataque naquele alvo. Confirmado, o mesmo alvo não pergunta de novo nesta sessão.
 */
export function ConfirmarAtaque({ nome, onConfirmar, onCancelar }: {
  nome: string;
  onConfirmar(): void;
  onCancelar(): void;
}) {
  useFechar(onCancelar, { modal: true });
  const cancelar = useRef<HTMLButtonElement>(null);
  // O foco começa no Cancelar: um Enter sem querer não ataca.
  useEffect(() => { cancelar.current?.focus(); }, []);

  return (
    <div className="modal" role="presentation" onClick={onCancelar}>
      <div role="alertdialog" aria-modal="true" aria-labelledby="ataque-inocente-titulo" onClick={e => e.stopPropagation()}>
        <Gump title={t('ataque.inocente.titulo')}>
          <p id="ataque-inocente-titulo">{t('ataque.inocente.texto', { nome })}</p>
          <p className="muted">{t('ataque.inocente.ajuda')}</p>
          <div className="row row--split">
            <button ref={cancelar} type="button" className="btn btn--ghost" onClick={onCancelar}>{t('comum.cancelar')}</button>
            <button type="button" className="btn btn--danger" onClick={onConfirmar}>{t('ataque.inocente.atacar')}</button>
          </div>
        </Gump>
      </div>
    </div>
  );
}
